import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Search } from 'lucide-react';

const Hero = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = () => {
    navigate(`/clinicas?search=${encodeURIComponent(searchTerm)}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="bg-gradient-to-br from-cyan-50 via-blue-50 to-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Encuentra la mejor clínica dental para tu sonrisa
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Directorio completo de clínicas dentales especializadas. Compara servicios y encuentra el profesional perfecto para tu tratamiento.
            </p>
            
            <div className="flex gap-2 mb-6">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <Input
                  type="text"
                  placeholder="Buscar por nombre, especialidad o ciudad..."
                  className="pl-10 h-12 text-base"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <Button 
                onClick={handleSearch}
                className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 h-12"
              >
                Buscar
              </Button>
            </div>
            
            <div className="flex flex-wrap gap-2 text-sm">
              <span className="text-gray-600">Búsquedas populares:</span>
              <button 
                onClick={() => navigate('/clinicas?especialidad=ortodoncia')}
                className="text-cyan-600 hover:text-cyan-700 hover:underline"
              >
                Ortodoncia
              </button>
              <span className="text-gray-400">•</span>
              <button 
                onClick={() => navigate('/clinicas?especialidad=implantologia')}
                className="text-cyan-600 hover:text-cyan-700 hover:underline"
              >
                Implantes
              </button>
              <span className="text-gray-400">•</span>
              <button 
                onClick={() => navigate('/clinicas?especialidad=estetica-dental')}
                className="text-cyan-600 hover:text-cyan-700 hover:underline"
              >
                Estética dental
              </button>
              <span className="text-gray-400">•</span>
              <button 
                onClick={() => navigate('/clinicas?ciudad=La Paz')}
                className="text-cyan-600 hover:text-cyan-700 hover:underline"
              >
                La Paz
              </button>
              <span className="text-gray-400">•</span>
              <button 
                onClick={() => navigate('/clinicas?ciudad=Asunción')}
                className="text-cyan-600 hover:text-cyan-700 hover:underline"
              >
                Asunción
              </button>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <img
                src="https://images.unsplash.com/photo-1629909615184-74f495363b67?q=80&w=2069&auto=format&fit=crop"
                alt="Sonrisa saludable"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
